import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MModalComponent } from '../m-modal/m-modal.component';
import { MProgressBarComponent } from '../m-progress-bar/m-progress-bar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-loading-state',
  templateUrl: './m-loading-state.component.html',
  imports: [MModalComponent, MProgressBarComponent]
})
export class MLoadingStateComponent {
  visible = input<boolean>(false);
  message = input<string>('Loading...');
  showHeader = input<boolean>(false);
  showFooter = input<boolean>(false);
}
